import { useEffect } from "react";
import { CheckCircle, XCircle, AlertTriangle, X } from "lucide-react";

const ICONS = {
  success: <CheckCircle size={18} className="text-green-500 flex-shrink-0" strokeWidth={2} />,
  error:   <XCircle    size={18} className="text-red-500   flex-shrink-0" strokeWidth={2} />,
  warning: <AlertTriangle size={18} className="text-amber-500 flex-shrink-0" strokeWidth={2} />,
};

const BG = {
  success: "bg-green-50 border-green-200 text-green-800",
  error:   "bg-red-50   border-red-200   text-red-800",
  warning: "bg-amber-50 border-amber-200 text-amber-800",
};

/**
 * Toast — inline persistent notification
 * Props: type ("success"|"error"|"warning"), message, onClose
 */
const Toast = ({ type = "success", message, onClose, autoDismiss = true }) => {
  useEffect(() => {
    if (!autoDismiss || !message) return;
    const t = setTimeout(onClose, 4000);
    return () => clearTimeout(t);
  }, [message, autoDismiss, onClose]);

  if (!message) return null;

  return (
    <div className={`flex items-start gap-3 px-4 py-3 rounded-2xl border font-outfit text-sm ${BG[type]} animate-fade-in`}>
      {ICONS[type]}
      <span className="flex-1">{message}</span>
      <button onClick={onClose} className="opacity-60 hover:opacity-100 transition-opacity flex-shrink-0">
        <X size={15} />
      </button>
    </div>
  );
};

export default Toast;
